import moment from "moment";
import { MarknadsprislistaTyp } from "~app/common/models/constants";
import { DateUtils } from "~app/common/utils/date-utils";
import { IMarknadsprislista } from "./marknadsprislista-model";

export class MarknadsprislistaViewModel {

    private readonly const = {
        vlg: "VLG",
        aktuell: "Aktuell",
        inaktuell: "Inaktuell",
        empty: "",
        dateFormat: DateUtils.dateformat
    };

    constructor(private readonly model: IMarknadsprislista) {
    }

    get id() {
        return this.model.id;
    }

    get violId() {
        return this.model.violId;
    }

    get benamning() {
        return this.model.benamning;
    }

    get vidLeveransGallande() {
        return this.model.vidLeveransGallande ? this.const.vlg : this.const.empty;
    }

    get galler() {
        return `${moment(this.model.gallerFrom).format(this.const.dateFormat)} - ${this.model.gallerTom != null
            ? moment(this.model.gallerTom ).format(this.const.dateFormat) : this.const.empty}`;
    }

    get aktuell() {
        return this.model.aktuell ? this.const.aktuell : this.const.inaktuell;
    }

    get typ() {
        return MarknadsprislistaTyp.AllaWithKeys[ this.model.typ];
    }

    get handelssortimentsgrupper() {
        return this.model.handelssortimentsgrupper.map(x => x.kortnamn).join(", ");
    }

    get resultatsomraden() {
        return this.model.resultatomraden.map(x => x.namn).join(", ");
    }
}
